module.exports = __webpack_public_path__ + "media/images/web_suite/feature_icons/icon_diagnostic-693693981b9453fe9d87a19531e20fc1.png";